import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ExcemptionStatusService } from '../app/excemption-status.service';

@Injectable({
  providedIn: 'root'
})
export class ExemptionService {
  private BASE_URL = environment.landmark_API_URL+"/exemption";

  constructor(private http: HttpClient, private exemptionStatusService: ExcemptionStatusService) { }

  requestExemption(message: string, binderId: number, clientName:string): Observable<any> {
    const request = {
      binderId: binderId,
      clientName: clientName,
      reason: message
    }
    this.exemptionStatusService.setStatus(null,true,message);
    console.log('requesting...',request);
    return this.http.post(`${this.BASE_URL}/request`, request);
  }

  getExemptionRequests(): Observable<any> {
    return this.http.get(`${this.BASE_URL}/requests`);
  }

  cancelRequest(requestId: number): Observable<any> {
    this.exemptionStatusService.setStatus(null,null,null);
    return this.http.post(`${this.BASE_URL}/cancel/${requestId}`, null);
  }

  respondToRequest(requestId: number, approved: boolean): Observable<any> {
    this.exemptionStatusService.setStatus(approved,null,null);
    return this.http.post(`${this.BASE_URL}/respond/${requestId}`, { approved: approved });
  }
}
